export const primary = {
  main: '#143666',
  dark: '#0C2043',
  light: '#596F96',
  contrastText: '#FFFFFF',
  border: '#899BB3',
  background: '#ECEFF3',
  border2: '#C4C4C4',
};

export const secondary = {
  main: '#F19100',
  dark: '#FBC064',
  light: '#C17400',
  contrastText: '#143666',
  background: '#FEF6EB',
  border: '#F8C880',
  hover: '#E5A137',
  skyBlue: '#00A3E9',
  yellow: '#E9C600',
};
export const text = {
  primary: 'rgba(0,5,10,0.87)',
  secondary: 'rgba(0,5,10,0.64)',
  disabled: 'rgba(0,5,10,0.38)',
  hint: 'rgba(0,5,10,0.38)',
  darkBlack: '#00050AA3',
  darkNavy: '#00050ADE',
};

export const error = {
  main: '#d2281b',
  light: '#e57373',
  dark: '#aa261c',
  sync: '#FF2929',
  contrastText: '#FFFFFF',
  text: '#54100B',
  background: '#FBE9E8',
  darkBackground: '#fdd5d5',
  lightBackground: '#fae9e8',
  negativeValue: '#ff0000',
};
export const info = {
  main: '#0075E0',
  light: '#64B5F6',
  dark: '#0157AB',
  aquaBlue: '#00B1F1',
  contrastText: '#FFFFFF',
  text: '#002F5A',
  background: '#E5F1FC',
};

export const warning = {
  main: '#FF9800',
  light: '#FFB74D',
  dark: '#F57C00',
  contrastText: 'rgba(0,0,0,0.87)',
  text: '#663D00',
  background: '#FFF5E5',
};

export const success = {
  main: '#0F8A0F',
  normal: '#8DC641',
  main2: '#4caf50',
  light: '#81C784',
  dark: '#0C610C',
  contrastText: '#ffffff',
  text: '#063706',
  background: '#DBEFDC',
  lightBackground: '#e6f3e7',
};

export const custom1 = {
  main: '#6D50FF',
  light: '#8A73FF',
  dark: '#5740CC',
  contrastText: '#ffffff',
  text: '#2C2066',
  background: '#F0EDFF',
};

export const custom2 = {
  main: '#FBAD33', // rgb(251, 173, 51)
  main2: '#F0840F',
  main5: '#ff9100',
  light: '#8A73FF',
  dark: '#5740CC',
  contrastText: '#ffffff',
  text: '#233759',
  background: '#F44336',
  backgroundLight: '#FBD9D7',
  border: '#CED2D9',
  main3: '#E5A137',
  main4: '#F0840F4D',
};

export const action = {
  active: 'rgba(0,0,0,0.54)',
  hover: 'rgba(0,0,0,0.04)',
  selected: 'rgba(20,54,102,0.04)',
  selectedHover: 'rgba(20,54,102,0.08)',
  disabled: 'rgba(0,0,0,0.26)',
  disabledBackground: 'rgba(0,0,0,0.12)',
  focus: 'rgba(0,0,0,0.12)',
};

export const common = {
  black: '#000',
  white: '#fff',
  icon: '#98a5b9',
};

export const divider = 'rgba(0,5,10,0.12)';

export const background = {
  default: '#fafafa',
  paper: '#ffffff',
  gradient:
    'linear-gradient(255deg, rgba(0, 177, 241, 0.14) 9.49%, rgba(241, 145, 0, 0.08) 51.23%, rgba(255, 162, 16, 0.12) 90.51%)',
  gradient2:
    'linear-gradient(to right, #2C395940, #F3792140, #52D3C440, #6D50FF30)',
  radialGradient1:
    'radial-gradient(86.68% 598.12% at 72.83% 156.88%, rgba(0, 177, 241, 0.14) 0%, rgba(241, 145, 0, 0.084) 51.52%, rgba(255, 162, 16, 0.12026) 100%)',
  radialGradient2:
    'radial-gradient(87.05% 600.62% at -6.43% 29.37%, rgba(0, 177, 241, 0.14) 0%, rgba(241, 145, 0, 0.084) 51.52%, rgba(255, 162, 16, 0.12026) 100%)',
  primaryGradient:
    'linear-gradient(243.22deg, #243859 -9.6%, #2C3959 14.29%, #3D3D58 53.25%, #554556 102.16%, #5C4755 115.48%)',
  animatedGradient:
    'linear-gradient(to right, #2C395940, #F3792140, #52D3C440, #6D50FF30)',
  chipBackground: '#EBEBEB',
  gradient3:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.00) 100%)',
  blueBackground: '#9287dd12',
  orangeYellowGradient:
    'linear-gradient(80.69deg, #f37a21 1.06%, #fbad35 98.94%)',
};

export const grey = {
  g50: '#fafafa',
  g70: '#f2f2f2',
  g100: '#f5f5f5',
  g200: '#eeeeee',
  g300: '#e0e0e0',
  g400: '#bdbdbd',
  g500: '#9e9e9e',
  g600: '#757575',
  g700: '#616161',
  g800: '#424242',
  g900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161',
  custom1: '#D3D7DD',
  custom2: '#637188',
  custom3: '#F3F6FB',
  custom4: '#637188',
  custom5: '#EBF0F5',
  custom6: '#98A5B9',
  custom7: '#F2F6FC',
  custom8: '#cfcfcf',
  custom9: '#465774',
  custom10: '#717e94',
  custom11: '#e8e8e8',
  custom12: '#0000000A',
};

export const other = {
  // not included in the theme
  border: 'rgba(0,0,0,0.23)',
  borderLight: '#dcdcdc',
  backdrop: 'rgba(0, 0, 0, 0.05)',
  tooltip: 'rgba(0,0,0,0.9)',
  snackbar: '#323232',
  filledinput: 'rgba(0,0,0,0.09)',
  lightBorder: '#FFFFFF3B',
  lightBorder2: '#23375944',
  lightBorder3: 'rgba(0,0,0, 0.02)',
  title: '#233759',
  customBoxShadow: '#00000029',
  icon: '#5F6D83',
  background: '#323639',
  background2: '#E6E9EE',
  navyBlue: '#244173',
  grey: '#E6E9EE',
  shadowColor: '#00000029',
  dividerBorder: '#C4C4C4',
  grey10: '#ccc',
  error: '#E13939',
  dashedBorder: '#F57C00',
  purple: '#7B61FF',
  skyBlue: '#60B5EA',
  cyan: '#52D3C4',
};

export const normalText = {
  main: '#212529',
  light: '#5F6D83',
  dark: '#6A737B',
  backgroundColor: '#FFF4E3',
  lightColor: '#eaedf1',
};

export const fileErrorColor = {
  fileErrColor: '#f10',
};

export const dailogueBox = {
  borderColor: '#24417380',
  background: '#24417314',
  blurBackground: 'rgba(0, 0, 0, 0.01)',
};

export const custom3 = {
  lavender: '#E8EAF6',
  indigo: '#1A237E',
  border: 'rgba(224, 224, 224, 1)',
  boxShadowColor: 'rgba(0, 0, 0, 0.05)',
  scrollTrackColor: '#f1f1f1',
  scrollThumbColor: '#888',
  scrollThumbHoverColor: '#555',
  overlayLoader: 'rgba(255, 255, 255, 0.4)',
};

export const galleryModalOverlay = 'rgba(0,0,0,0.85)';
export const galleryModalButton = 'rgba(0,0,0,0.5)';
export const galleryModalNavButton = 'rgba(0,0,0,0.7)';
export const galleryModalCounter = 'rgba(0,0,0,0.7)';
export const galleryModalPanel = 'rgba(255,255,255,0.95)';

export const userMessageBg = '#b9c0cd';
export const assistantTitleColor = '#f1e5e5';
export const assistantTitleBg = '#2e3959';
export const folderIconColor = '#FBAD34';

export const alpha = {
  black2: 'rgba(0,0,0,0.02)',
  black4: 'rgba(0,0,0,0.04)',
  black8: 'rgba(0,0,0,0.08)',
  black12: 'rgba(0,0,0,0.12)',
  black26: 'rgba(0,0,0,0.26)',
  black40: 'rgba(0,0,0,0.4)',
  black50: 'rgba(0,0,0,0.5)',
  black70: 'rgba(0,0,0,0.7)',
  black85: 'rgba(0,0,0,0.85)',
  white95: 'rgba(255,255,255,0.95)',
  white10: 'rgba(255, 255, 255, 0.1)',
};

export const neutral = {
  gray: '#b9c0cd',
  cream: '#f1e5e5',
  navy: '#2e3959',
  white95: 'rgba(255,255,255,0.95)',
};
